module.exports = __webpack_public_path__ + "img/矩形2.15566733.svg";